import { Agreement } from './Agreement';
import { Documents } from './Documents';
import { Form } from './Form';
import { Signature } from './Signature';
import { SubmitButton } from './SubmitButton';

export default { Agreement, Documents, Form, Signature, SubmitButton };
